import i18next from 'i18next';
import dayjs from 'dayjs';
import type { Quotation } from 'src/quotations/types';
import { noleggiatoreLabel, sourceLabel } from './columnsData';

export function buildExportData(data: Quotation[]): (string | number)[][] {
	const headers = [
		i18next.t('quotation_code', { defaultValue: 'Codice preventivo' }),
		i18next.t('creation_date', { defaultValue: 'Data di creazione' }),
		i18next.t('quotation_recipient_short', { defaultValue: 'Intestatario' }),
		i18next.t('quotation_created_by', { defaultValue: 'Utente' }),
		i18next.t('reference_partner', { defaultValue: 'Partner di riferimento' }),
		i18next.t('quotation_source', { defaultValue: 'Origine' }),
		i18next.t('brand', { defaultValue: 'Marca' }),
		i18next.t('model', { defaultValue: 'Modello' }),
		i18next.t('car_setup', { defaultValue: 'Allestimento' }),
		i18next.t('rental_company', { defaultValue: 'Noleggiatore' }),
		i18next.t('rental_fee', { defaultValue: 'Canone' }),
		i18next.t('duration', { defaultValue: 'Durata' }),
		i18next.t('total_km', { defaultValue: 'KM totali' }),
		i18next.t('downpayment', { defaultValue: 'Anticipo' }),
	];

	const rows = data.map((q) => [
		q.code ?? '',
		q.createdAt ? dayjs(q.createdAt).format('DD/MM/YYYY HH:mm') : '',
		q.client ?? '',
		q.createdBy ?? '',
		q.userAffiliation ?? '',
		sourceLabel(q.source),
		q.makeLabel ?? '',
		q.modelLabel ?? '',
		q.trimLabel ?? '',
		noleggiatoreLabel(q) ?? '',
		q.canone ?? '',
		q.durata ?? '',
		q.kmTotali ?? '',
		q.anticipo ?? '',
	]);

	return [headers, ...rows];
}
